export default __webpack_public_path__ + "static/media/1.4cf33d27.png";